import createNamespaceContext from './helper/createNamespaceContext';
export const ATLAS_CONTEXT = 'atlasCtx';
export const AtlasAnalyticsContext = createNamespaceContext(ATLAS_CONTEXT, 'AtlasAnalyticsContext');